import React from 'react';
import Box from '@mui/material/Box';
import { colors } from '../../../colors';
import invoiceIcon from '../../../assets/images/icons/invoice-white.svg';
import debtCollectionIcon from '../../../assets/images/icons/debt-collection-white.svg';
import convenepayIcon from '../../../assets/images/icons/convenepay.svg';
import cashIcon from '../../../assets/images/icons/cash.svg';
import cardIcon from '../../../assets/images/icons/card.svg';
import { DebtCollectionCaseType, PaymentType } from '../../../api/client'

interface Props {
  variant: any,
  paymentType: PaymentType,
  caseType: DebtCollectionCaseType | undefined;
  isHalted: boolean | undefined;
}

export default function DebtorClaimIcon(props: Props) {
  const icons = {};
  icons['LeapClaimActive'] = {
    'Default': { tooltip: props.isHalted === true ? 'Stanset' : 'Aktiv', backgroundColor: props.isHalted === true ? colors.orange : colors.blue, path: invoiceIcon },
    'MobilePay': { tooltip: 'Aktiv ConvenePay', backgroundColor: colors.blue, path: convenepayIcon }
  };

  icons['LeapClaimPaid'] = {
    'Default': { tooltip: 'Betalt', backgroundColor: colors.green, path: invoiceIcon },
    'MobilePay': { tooltip: 'Betalt ConvenePay', backgroundColor: colors.green, path: convenepayIcon },
    'Card': { tooltip: 'Betalt med kort', backgroundColor: colors.green, path: cardIcon },
    'Cash': { tooltip: 'Betalt med kontant', backgroundColor: colors.green, path: cashIcon }
  };

  icons['LeapClaimCredited'] = { 'Default': { tooltip: 'Kreditert', backgroundColor: colors.darkGray, path: invoiceIcon } };
  icons['LeapClaimForfeited'] = { 'Default': { tooltip: 'Ettergitt', backgroundColor: colors.darkGray, path: invoiceIcon } };
  icons['LeapClaimExpired'] = { 'Default': { tooltip: 'Foreldet krav', backgroundColor: colors.secondary.zeus, path: invoiceIcon } };
  icons['LeapClaimExternalDebtCollection'] = { 'Default': { tooltip: 'Sendt til ekstern inkasso', backgroundColor: colors.red, path: invoiceIcon } };

  icons['LeapDebtCollectionClaimActive'] = { 'Default': { tooltip: getTooltipByCaseType(), backgroundColor: props.caseType === DebtCollectionCaseType.Judicial ? colors.grape : colors.red, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimPaid'] = { 'Default': { tooltip: 'Betalt inkasso', backgroundColor: colors.green, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimHalted'] = { 'Default': { tooltip: 'Betalt inkasso', backgroundColor: colors.orange, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimCredited'] = { 'Default': { tooltip: 'Kreditert inkasso', backgroundColor: colors.darkGray, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimForfeited'] = { 'Default': { tooltip: 'Ettergitt inkasso', backgroundColor: colors.darkGray, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimClosed'] = { 'Default': { tooltip: 'Avsluttet inkasso', backgroundColor: colors.darkGray, path: debtCollectionIcon } };
  icons['LeapDebtCollectionClaimExpired'] = { 'Default': { tooltip: 'Foreldet inkasso', backgroundColor: colors.secondary.zeus, path: debtCollectionIcon } };

  function getTooltipByCaseType() {

    switch (props.caseType) {
      case DebtCollectionCaseType.Judicial:
        return 'Rettslig inkasso';
      case DebtCollectionCaseType.Minor:
        return 'Purring';
      default:
        return 'Inkasso';
    }
  }

  const icon = icons[props.variant][PaymentType[props.paymentType]] || icons[props.variant]['Default'];

  const backgroundColor = () => {
    return icon.backgroundColor;
  };

  return (
    <Box sx={{
        flex: 1,
        padding: '1em',
        maxWidth: '32px',
        backgroundColor: backgroundColor
      }}
    >
      <img src={ icon.path } alt="icon" title={ icon.tooltip } style={{
          display: 'block'
        }}
      />
    </Box>
  );
};
